import React from 'react'
import styled from 'styled-components/macro'

interface BodyWrapperProps {
  margin?: string
  maxWidth?: string
}
export const BodyWrapper = styled.div<BodyWrapperProps>`
  position: relative;
  margin-top: ${({ margin }) => margin ?? '0px'};
  max-width: ${({ maxWidth }) => maxWidth || '540px'};
  width: 100%;
  ${({ theme }) => theme.borderCard}
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 20px;
  padding: 24px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 16px;
    margin: 0 20px;
    width: calc(100% - 40px);
  `};
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children, ...rest }: { children: React.ReactNode } & BodyWrapperProps) {
  return <BodyWrapper {...rest}>{children}</BodyWrapper>
}

const AppBodyWrap = styled(BodyWrapper)<{ disabledScroll?: boolean }>`
  ${({ theme, disabledScroll }) => theme.mediaWidth.upToExtraSmall`
    margin: 0;
    width: 100%;
    padding: 18px 20px;
    border-radius: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    position: fixed;
    bottom: 0;
    left:0;
    animation: slideIn 200ms forwards;
    max-height: 90vh;
    overflow: ${disabledScroll ? 'hidden' : 'scroll'};
  `};
`
export const AppBodyModal = ({
  disabledScroll,
  ...rest
}: { children: React.ReactNode } & BodyWrapperProps & { disabledScroll?: boolean }) => {
  return <AppBodyWrap {...rest} disabledScroll={disabledScroll}></AppBodyWrap>
}
